import React from 'react'

const Rapports = () => {
  return (
    <div>
      Rapports
    </div>
  )
}

export default Rapports
